import {useSearchParams} from 'react-router-dom';
import {useCallback} from 'react';

import {SEARCH_PARAM} from 'shared/lib/filterHelper';

export const useSearchHandler = (paramName = SEARCH_PARAM) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const onSearchSubmit = useCallback((search: string) => {
        const next = new URLSearchParams(searchParams);
        const trimmedSearch = search.trim();

        if (trimmedSearch) {
            next.set(paramName, trimmedSearch);
        } else {
            next.delete(paramName);
        }
        next.set('page', '1');
        setSearchParams(next);
    }, [searchParams, setSearchParams, paramName]);

    return {
        searchParams,
        currentValue: searchParams.get(paramName) || '',
        onSearchSubmit,
    };
};
